export const MENU_MAX_HEIGHT = 70;
